import { request } from "../../Services/Api"

const buildFormData = (data) => {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (key !== "file_list" && value) {
      formData.append(key, value)
    }
  })
  if (data.file_list) {
    data.file_list.forEach((file) => {
      formData.append("files", file.originFileObj)
    })
  }
  return formData
}

const requestTypesMap = {
  enrollments: "/user/requests/enrollments",
  receipts: "/user/requests/receipts",
  integrations: "/admin_panel/new_integration",
  auto_refund: "/user/requests/auto-refund-amount",
  credits: "/payments/credit-requests"
}

export const saveScreenshotsRequest = ({ id, requestType, ...data }) => {
  const headers = { "Content-Type": "multipart/form-data" }
  const formData = buildFormData(data)
  return request.api.post(`${requestTypesMap[requestType]}/${id}/attachments/upload/`, formData, {
    headers
  })
}

export const deleteScreenshotsRequest = ({ id, requestType, delete_files }) => {
  const params = new URLSearchParams()
  delete_files.forEach((id) => params.append("id", id))
  return request.api.delete(
    `${requestTypesMap[requestType]}/${id}/attachments/delete/?${params.toString()}`
  )
}

export const updateCommentRequest = ({ id, requestType, ...data }) => {
  return request.api.patch(`${requestTypesMap[requestType]}/${id}/`, data)
}
